import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const SurveyPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.Survey}
        fetchRecordsUrl={AdminReqUrls.admin__survey__mainPage_fetch_recordList}
        showMultipleDelete={true}
    />)
});
export default SurveyPage;
